import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styles from "./MyProfilePersonalInfo.module.css";
import { LanguageContext } from "../LanguageContext/LanguageContext";
import axios from "axios";
import ProfileNavigation from "../ProfileNavigation/ProfileNavigation";

const lmsUrl = import.meta.env.VITE_LMS_URL;
// Moodle Web Service Configuration
const MOODLE_BASE_URL = `${lmsUrl}`; // Replace with your Moodle URL
const MOODLE_TOKEN = "2a722fa95e3614ef3e297fb6154fd3e8"; // Replace with your Web Service token
const marketingFrontendUrl = import.meta.env.VITE_MARKETING_FRONTEND_URL;
const marketingBackendUrl = import.meta.env.VITE_MARKETING_BACKEND_URL;

// List of all countries
const COUNTRIES = [
  { value: "afghanistan", label_en: "Afghanistan", label_ar: "أفغانستان" },
  { value: "albania", label_en: "Albania", label_ar: "ألبانيا" },
  { value: "algeria", label_en: "Algeria", label_ar: "الجزائر" },
  { value: "andorra", label_en: "Andorra", label_ar: "أندورا" },
  { value: "angola", label_en: "Angola", label_ar: "أنغولا" },
  {
    value: "antiguaAndBarbuda",
    label_en: "Antigua and Barbuda",
    label_ar: "أنتيغوا وباربودا",
  },
  { value: "argentina", label_en: "Argentina", label_ar: "الأرجنتين" },
  { value: "armenia", label_en: "Armenia", label_ar: "أرمينيا" },
  { value: "australia", label_en: "Australia", label_ar: "أستراليا" },
  { value: "austria", label_en: "Austria", label_ar: "النمسا" },
  { value: "azerbaijan", label_en: "Azerbaijan", label_ar: "أذربيجان" },
  { value: "bahamas", label_en: "Bahamas", label_ar: "الباهاما" },
  { value: "bahrain", label_en: "Bahrain", label_ar: "البحرين" },
  { value: "bangladesh", label_en: "Bangladesh", label_ar: "بنغلاديش" },
  { value: "barbados", label_en: "Barbados", label_ar: "بربادوس" },
  { value: "belarus", label_en: "Belarus", label_ar: "بيلاروسيا" },
  { value: "belgium", label_en: "Belgium", label_ar: "بلجيكا" },
  { value: "belize", label_en: "Belize", label_ar: "بليز" },
  { value: "benin", label_en: "Benin", label_ar: "بنين" },
  { value: "bhutan", label_en: "Bhutan", label_ar: "بوتان" },
  { value: "bolivia", label_en: "Bolivia", label_ar: "بوليفيا" },
  {
    value: "bosniaAndHerzegovina",
    label_en: "Bosnia and Herzegovina",
    label_ar: "البوسنة والهرسك",
  },
  { value: "botswana", label_en: "Botswana", label_ar: "بوتسوانا" },
  { value: "brazil", label_en: "Brazil", label_ar: "البرازيل" },
  { value: "brunei", label_en: "Brunei", label_ar: "بروناي" },
  { value: "bulgaria", label_en: "Bulgaria", label_ar: "بلغاريا" },
  { value: "burkinaFaso", label_en: "Burkina Faso", label_ar: "بوركينا فاسو" },
  { value: "burundi", label_en: "Burundi", label_ar: "بوروندي" },
  { value: "caboVerde", label_en: "Cabo Verde", label_ar: "الرأس الأخضر" },
  { value: "cambodia", label_en: "Cambodia", label_ar: "كمبوديا" },
  { value: "cameroon", label_en: "Cameroon", label_ar: "الكاميرون" },
  { value: "canada", label_en: "Canada", label_ar: "كندا" },
  {
    value: "centralAfricanRepublic",
    label_en: "Central African Republic",
    label_ar: "جمهورية أفريقيا الوسطى",
  },
  { value: "chad", label_en: "Chad", label_ar: "تشاد" },
  { value: "chile", label_en: "Chile", label_ar: "تشيلي" },
  { value: "china", label_en: "China", label_ar: "الصين" },
  { value: "colombia", label_en: "Colombia", label_ar: "كولومبيا" },
  { value: "comoros", label_en: "Comoros", label_ar: "جزر القمر" },
  { value: "congo", label_en: "Congo", label_ar: "الكونغو" },
  { value: "costaRica", label_en: "Costa Rica", label_ar: "كوستاريكا" },
  { value: "croatia", label_en: "Croatia", label_ar: "كرواتيا" },
  { value: "cuba", label_en: "Cuba", label_ar: "كوبا" },
  { value: "cyprus", label_en: "Cyprus", label_ar: "قبرص" },
  {
    value: "czechRepublic",
    label_en: "Czech Republic",
    label_ar: "جمهورية التشيك",
  },
  {
    value: "democraticRepublicOfTheCongo",
    label_en: "Democratic Republic of the Congo",
    label_ar: "جمهورية الكونغو الديمقراطية",
  },
  { value: "denmark", label_en: "Denmark", label_ar: "الدنمارك" },
  { value: "djibouti", label_en: "Djibouti", label_ar: "جيبوتي" },
  { value: "dominica", label_en: "Dominica", label_ar: "دومينيكا" },
  {
    value: "dominicanRepublic",
    label_en: "Dominican Republic",
    label_ar: "جمهورية الدومينيكان",
  },
  { value: "ecuador", label_en: "Ecuador", label_ar: "الإكوادور" },
  { value: "egypt", label_en: "Egypt", label_ar: "مصر" },
  { value: "elSalvador", label_en: "El Salvador", label_ar: "السلفادور" },
  {
    value: "equatorialGuinea",
    label_en: "Equatorial Guinea",
    label_ar: "غينيا الاستوائية",
  },
  { value: "eritrea", label_en: "Eritrea", label_ar: "إريتريا" },
  { value: "estonia", label_en: "Estonia", label_ar: "إستونيا" },
  { value: "eswatini", label_en: "Eswatini", label_ar: "إسواتيني" },
  { value: "ethiopia", label_en: "Ethiopia", label_ar: "إثيوبيا" },
  { value: "fiji", label_en: "Fiji", label_ar: "فيجي" },
  { value: "finland", label_en: "Finland", label_ar: "فنلندا" },
  { value: "france", label_en: "France", label_ar: "فرنسا" },
  { value: "gabon", label_en: "Gabon", label_ar: "الغابون" },
  { value: "gambia", label_en: "Gambia", label_ar: "غامبيا" },
  { value: "georgia", label_en: "Georgia", label_ar: "جورجيا" },
  { value: "germany", label_en: "Germany", label_ar: "ألمانيا" },
  { value: "ghana", label_en: "Ghana", label_ar: "غانا" },
  { value: "greece", label_en: "Greece", label_ar: "اليونان" },
  { value: "grenada", label_en: "Grenada", label_ar: "غرينادا" },
  { value: "guatemala", label_en: "Guatemala", label_ar: "غواتيمالا" },
  { value: "guinea", label_en: "Guinea", label_ar: "غينيا" },
  { value: "guineaBissau", label_en: "Guinea-Bissau", label_ar: "غينيا بيساو" },
  { value: "guyana", label_en: "Guyana", label_ar: "غيانا" },
  { value: "haiti", label_en: "Haiti", label_ar: "هايتي" },
  { value: "honduras", label_en: "Honduras", label_ar: "هندوراس" },
  { value: "hungary", label_en: "Hungary", label_ar: "المجر" },
  { value: "iceland", label_en: "Iceland", label_ar: "آيسلندا" },
  { value: "india", label_en: "India", label_ar: "الهند" },
  { value: "indonesia", label_en: "Indonesia", label_ar: "إندونيسيا" },
  { value: "iran", label_en: "Iran", label_ar: "إيران" },
  { value: "iraq", label_en: "Iraq", label_ar: "العراق" },
  { value: "ireland", label_en: "Ireland", label_ar: "أيرلندا" },
  { value: "israel", label_en: "Israel", label_ar: "إسرائيل" },
  { value: "italy", label_en: "Italy", label_ar: "إيطاليا" },
  { value: "jamaica", label_en: "Jamaica", label_ar: "جامايكا" },
  { value: "japan", label_en: "Japan", label_ar: "اليابان" },
  { value: "jordan", label_en: "Jordan", label_ar: "الأردن" },
  { value: "kazakhstan", label_en: "Kazakhstan", label_ar: "كازاخستان" },
  { value: "kenya", label_en: "Kenya", label_ar: "كينيا" },
  { value: "kiribati", label_en: "Kiribati", label_ar: "كيريباتي" },
  { value: "kuwait", label_en: "Kuwait", label_ar: "الكويت" },
  { value: "kyrgyzstan", label_en: "Kyrgyzstan", label_ar: "قيرغيزستان" },
  { value: "laos", label_en: "Laos", label_ar: "لاوس" },
  { value: "latvia", label_en: "Latvia", label_ar: "لاتفيا" },
  { value: "lebanon", label_en: "Lebanon", label_ar: "لبنان" },
  { value: "lesotho", label_en: "Lesotho", label_ar: "ليسوتو" },
  { value: "liberia", label_en: "Liberia", label_ar: "ليبيريا" },
  { value: "libya", label_en: "Libya", label_ar: "ليبيا" },
  { value: "liechtenstein", label_en: "Liechtenstein", label_ar: "ليختنشتاين" },
  { value: "lithuania", label_en: "Lithuania", label_ar: "ليتوانيا" },
  { value: "luxembourg", label_en: "Luxembourg", label_ar: "لوكسمبورغ" },
  { value: "madagascar", label_en: "Madagascar", label_ar: "مدغشقر" },
  { value: "malawi", label_en: "Malawi", label_ar: "مالاوي" },
  { value: "malaysia", label_en: "Malaysia", label_ar: "ماليزيا" },
  { value: "maldives", label_en: "Maldives", label_ar: "المالديف" },
  { value: "mali", label_en: "Mali", label_ar: "مالي" },
  { value: "malta", label_en: "Malta", label_ar: "مالطا" },
  {
    value: "marshallIslands",
    label_en: "Marshall Islands",
    label_ar: "جزر مارشال",
  },
  { value: "mauritania", label_en: "Mauritania", label_ar: "موريتانيا" },
  { value: "mauritius", label_en: "Mauritius", label_ar: "موريشيوس" },
  { value: "mexico", label_en: "Mexico", label_ar: "المكسيك" },
  { value: "micronesia", label_en: "Micronesia", label_ar: "ميكرونيزيا" },
  { value: "moldova", label_en: "Moldova", label_ar: "مولدوفا" },
  { value: "monaco", label_en: "Monaco", label_ar: "موناكو" },
  { value: "mongolia", label_en: "Mongolia", label_ar: "منغوليا" },
  { value: "montenegro", label_en: "Montenegro", label_ar: "الجبل الأسود" },
  { value: "morocco", label_en: "Morocco", label_ar: "المغرب" },
  { value: "mozambique", label_en: "Mozambique", label_ar: "موزمبيق" },
  { value: "myanmar", label_en: "Myanmar", label_ar: "ميانمار" },
  { value: "namibia", label_en: "Namibia", label_ar: "ناميبيا" },
  { value: "nauru", label_en: "Nauru", label_ar: "ناورو" },
  { value: "nepal", label_en: "Nepal", label_ar: "نيبال" },
  { value: "netherlands", label_en: "Netherlands", label_ar: "هولندا" },
  { value: "newZealand", label_en: "New Zealand", label_ar: "نيوزيلندا" },
  { value: "nicaragua", label_en: "Nicaragua", label_ar: "نيكاراغوا" },
  { value: "niger", label_en: "Niger", label_ar: "النيجر" },
  { value: "nigeria", label_en: "Nigeria", label_ar: "نيجيريا" },
  { value: "northKorea", label_en: "North Korea", label_ar: "كوريا الشمالية" },
  {
    value: "northMacedonia",
    label_en: "North Macedonia",
    label_ar: "مقدونيا الشمالية",
  },
  { value: "norway", label_en: "Norway", label_ar: "النرويج" },
  { value: "oman", label_en: "Oman", label_ar: "عمان" },
  { value: "pakistan", label_en: "Pakistan", label_ar: "باكستان" },
  { value: "palau", label_en: "Palau", label_ar: "بالاو" },
  { value: "palestine", label_en: "Palestine", label_ar: "فلسطين" },
  { value: "panama", label_en: "Panama", label_ar: "بنما" },
  {
    value: "papuaNewGuinea",
    label_en: "Papua New Guinea",
    label_ar: "بابوا غينيا الجديدة",
  },
  { value: "paraguay", label_en: "Paraguay", label_ar: "باراغواي" },
  { value: "peru", label_en: "Peru", label_ar: "بيرو" },
  { value: "philippines", label_en: "Philippines", label_ar: "الفلبين" },
  { value: "poland", label_en: "Poland", label_ar: "بولندا" },
  { value: "portugal", label_en: "Portugal", label_ar: "البرتغال" },
  { value: "qatar", label_en: "Qatar", label_ar: "قطر" },
  { value: "romania", label_en: "Romania", label_ar: "رومانيا" },
  { value: "russia", label_en: "Russia", label_ar: "روسيا" },
  { value: "rwanda", label_en: "Rwanda", label_ar: "رواندا" },
  {
    value: "saintKittsAndNevis",
    label_en: "Saint Kitts and Nevis",
    label_ar: "سانت كيتس ونيفيس",
  },
  { value: "saintLucia", label_en: "Saint Lucia", label_ar: "سانت لوسيا" },
  {
    value: "saintVincentAndTheGrenadines",
    label_en: "Saint Vincent and the Grenadines",
    label_ar: "سانت فنسنت وجزر غرينادين",
  },
  { value: "samoa", label_en: "Samoa", label_ar: "ساموا" },
  { value: "sanMarino", label_en: "San Marino", label_ar: "سان مارينو" },
  {
    value: "saoTomeAndPrincipe",
    label_en: "Sao Tome and Principe",
    label_ar: "ساو تومي وبرينسيبي",
  },
  {
    value: "saudiArabia",
    label_en: "Saudi Arabia",
    label_ar: "المملكة العربية السعودية",
  },
  { value: "senegal", label_en: "Senegal", label_ar: "السنغال" },
  { value: "serbia", label_en: "Serbia", label_ar: "صربيا" },
  { value: "seychelles", label_en: "Seychelles", label_ar: "سيشيل" },
  { value: "sierraLeone", label_en: "Sierra Leone", label_ar: "سيراليون" },
  { value: "singapore", label_en: "Singapore", label_ar: "سنغافورة" },
  { value: "slovakia", label_en: "Slovakia", label_ar: "سلوفاكيا" },
  { value: "slovenia", label_en: "Slovenia", label_ar: "سلوفينيا" },
  {
    value: "solomonIslands",
    label_en: "Solomon Islands",
    label_ar: "جزر سليمان",
  },
  { value: "somalia", label_en: "Somalia", label_ar: "الصومال" },
  { value: "southAfrica", label_en: "South Africa", label_ar: "جنوب أفريقيا" },
  { value: "southKorea", label_en: "South Korea", label_ar: "كوريا الجنوبية" },
  { value: "southSudan", label_en: "South Sudan", label_ar: "جنوب السودان" },
  { value: "spain", label_en: "Spain", label_ar: "إسبانيا" },
  { value: "sriLanka", label_en: "Sri Lanka", label_ar: "سريلانكا" },
  { value: "sudan", label_en: "Sudan", label_ar: "السودان" },
  { value: "suriname", label_en: "Suriname", label_ar: "سورينام" },
  { value: "sweden", label_en: "Sweden", label_ar: "السويد" },
  { value: "switzerland", label_en: "Switzerland", label_ar: "سويسرا" },
  { value: "syria", label_en: "Syria", label_ar: "سوريا" },
  { value: "taiwan", label_en: "Taiwan", label_ar: "تايوان" },
  { value: "tajikistan", label_en: "Tajikistan", label_ar: "طاجيكستان" },
  { value: "tanzania", label_en: "Tanzania", label_ar: "تنزانيا" },
  { value: "thailand", label_en: "Thailand", label_ar: "تايلاند" },
  { value: "timorLeste", label_en: "Timor-Leste", label_ar: "تيمور الشرقية" },
  { value: "togo", label_en: "Togo", label_ar: "توغو" },
  { value: "tonga", label_en: "Tonga", label_ar: "تونغا" },
  {
    value: "trinidadAndTobago",
    label_en: "Trinidad and Tobago",
    label_ar: "ترينيداد وتوباغو",
  },
  { value: "tunisia", label_en: "Tunisia", label_ar: "تونس" },
  { value: "turkey", label_en: "Turkey", label_ar: "تركيا" },
  { value: "turkmenistan", label_en: "Turkmenistan", label_ar: "تركمانستان" },
  { value: "tuvalu", label_en: "Tuvalu", label_ar: "توفالو" },
  { value: "uganda", label_en: "Uganda", label_ar: "أوغندا" },
  { value: "ukraine", label_en: "Ukraine", label_ar: "أوكرانيا" },
  {
    value: "unitedArabEmirates",
    label_en: "United Arab Emirates",
    label_ar: "الإمارات العربية المتحدة",
  },
  {
    value: "unitedKingdom",
    label_en: "United Kingdom",
    label_ar: "المملكة المتحدة",
  },
  {
    value: "unitedStates",
    label_en: "United States",
    label_ar: "الولايات المتحدة",
  },
  { value: "uruguay", label_en: "Uruguay", label_ar: "أوروغواي" },
  { value: "uzbekistan", label_en: "Uzbekistan", label_ar: "أوزبكستان" },
  { value: "vanuatu", label_en: "Vanuatu", label_ar: "فانواتو" },
  {
    value: "vaticanCity",
    label_en: "Vatican City",
    label_ar: "مدينة الفاتيكان",
  },
  { value: "venezuela", label_en: "Venezuela", label_ar: "فنزويلا" },
  { value: "vietnam", label_en: "Vietnam", label_ar: "فيتنام" },
  { value: "yemen", label_en: "Yemen", label_ar: "اليمن" },
  { value: "zambia", label_en: "Zambia", label_ar: "زامبيا" },
  { value: "zimbabwe", label_en: "Zimbabwe", label_ar: "زيمبابوي" },
];

const TIMEZONES = [
  { value: "UTC", label_en: "UTC", label_ar: "التوقيت العالمي المنسق" },
  {
    value: "Europe/London",
    label_en: "Europe/London",
    label_ar: "أوروبا/لندن",
  },
  { value: "Europe/Paris", label_en: "Europe/Paris", label_ar: "أوروبا/باريس" },
  {
    value: "Europe/Berlin",
    label_en: "Europe/Berlin",
    label_ar: "أوروبا/برلين",
  },
  {
    value: "Europe/Madrid",
    label_en: "Europe/Madrid",
    label_ar: "أوروبا/مدريد",
  },
  { value: "Europe/Rome", label_en: "Europe/Rome", label_ar: "أوروبا/روما" },
  {
    value: "Europe/Moscow",
    label_en: "Europe/Moscow",
    label_ar: "أوروبا/موسكو",
  },
  { value: "Asia/Dubai", label_en: "Asia/Dubai", label_ar: "آسيا/دبي" },
  { value: "Asia/Riyadh", label_en: "Asia/Riyadh", label_ar: "آسيا/الرياض" },
  { value: "Asia/Tehran", label_en: "Asia/Tehran", label_ar: "آسيا/طهران" },
  { value: "Asia/Tokyo", label_en: "Asia/Tokyo", label_ar: "آسيا/طوكيو" },
  {
    value: "Asia/Shanghai",
    label_en: "Asia/Shanghai",
    label_ar: "آسيا/شنغهاي",
  },
  { value: "Asia/Kolkata", label_en: "Asia/Kolkata", label_ar: "آسيا/كولكاتا" },
  {
    value: "Asia/Singapore",
    label_en: "Asia/Singapore",
    label_ar: "آسيا/سنغافورة",
  },
  {
    value: "Asia/Hong_Kong",
    label_en: "Asia/Hong Kong",
    label_ar: "آسيا/هونغ كونغ",
  },
  { value: "Asia/Seoul", label_en: "Asia/Seoul", label_ar: "آسيا/سيول" },
  { value: "Asia/Jakarta", label_en: "Asia/Jakarta", label_ar: "آسيا/جاكرتا" },
  { value: "Asia/Manila", label_en: "Asia/Manila", label_ar: "آسيا/مانيلا" },
  { value: "Asia/Bangkok", label_en: "Asia/Bangkok", label_ar: "آسيا/بانكوك" },
  {
    value: "Australia/Sydney",
    label_en: "Australia/Sydney",
    label_ar: "أستراليا/سيدني",
  },
  {
    value: "Australia/Melbourne",
    label_en: "Australia/Melbourne",
    label_ar: "أستراليا/ملبورن",
  },
  {
    value: "Australia/Perth",
    label_en: "Australia/Perth",
    label_ar: "أستراليا/بيرث",
  },
  {
    value: "America/New_York",
    label_en: "America/New York",
    label_ar: "أمريكا/نيويورك",
  },
  {
    value: "America/Los_Angeles",
    label_en: "America/Los Angeles",
    label_ar: "أمريكا/لوس أنجلوس",
  },
  {
    value: "America/Chicago",
    label_en: "America/Chicago",
    label_ar: "أمريكا/شيكاغو",
  },
  {
    value: "America/Denver",
    label_en: "America/Denver",
    label_ar: "أمريكا/دنفر",
  },
  {
    value: "America/Toronto",
    label_en: "America/Toronto",
    label_ar: "أمريكا/تورونتو",
  },
  {
    value: "America/Vancouver",
    label_en: "America/Vancouver",
    label_ar: "أمريكا/فانكوفر",
  },
  {
    value: "America/Mexico_City",
    label_en: "America/Mexico City",
    label_ar: "أمريكا/مكسيكو سيتي",
  },
  {
    value: "America/Sao_Paulo",
    label_en: "America/Sao Paulo",
    label_ar: "أمريكا/ساو باولو",
  },
  {
    value: "America/Argentina/Buenos_Aires",
    label_en: "America/Argentina/Buenos Aires",
    label_ar: "أمريكا/الأرجنتين/بوينس آيرس",
  },
  {
    value: "Africa/Cairo",
    label_en: "Africa/Cairo",
    label_ar: "أفريقيا/القاهرة",
  },
  {
    value: "Africa/Johannesburg",
    label_en: "Africa/Johannesburg",
    label_ar: "أفريقيا/جوهانسبرغ",
  },
  {
    value: "Africa/Lagos",
    label_en: "Africa/Lagos",
    label_ar: "أفريقيا/لاغوس",
  },
  {
    value: "Africa/Nairobi",
    label_en: "Africa/Nairobi",
    label_ar: "أفريقيا/نيروبي",
  },
  {
    value: "Africa/Casablanca",
    label_en: "Africa/Casablanca",
    label_ar: "أفريقيا/الدار البيضاء",
  },
];

// Add these constants at the top with other constants
const GENDERS = [
  { value: "male", label_en: "Male", label_ar: "ذكر" },
  { value: "female", label_en: "Female", label_ar: "أنثى" },
];

const AREAS_OF_INTEREST = [
  {
    value: "writing_and_development",
    label_en: "Writing and Development",
    label_ar: "الكتابة والتطوير",
  },
  { value: "producing", label_en: "Producing", label_ar: "الإنتاج" },
  { value: "directing", label_en: "Directing", label_ar: "الإخراج" },
  { value: "cinematography", label_en: "Cinematography", label_ar: "التصوير" },
  {
    value: "sound_recording",
    label_en: "Sound Recording",
    label_ar: "تسجيل الصوت",
  },
  {
    value: "post_production",
    label_en: "Post-Production",
    label_ar: "المونتاج",
  },
  { value: "acting", label_en: "Acting", label_ar: "التمثيل" },
  {
    value: "marketing_and_distribution",
    label_en: "Marketing and Distribution",
    label_ar: "التسويق والتوزيع",
  },
  { value: "other", label_en: "Other", label_ar: "آخرى" },
];

async function getUserIdByEmail(email) {
  try {
    const response = await axios.post(
      `${MOODLE_BASE_URL}/webservice/rest/server.php`,
      null,
      {
        params: {
          wstoken: MOODLE_TOKEN,
          wsfunction: "core_user_get_users",
          moodlewsrestformat: "json",
          "criteria[0][key]": "email",
          "criteria[0][value]": email,
        },
      }
    );
    const users = response.data.users;

    if (users && users.length > 0) {
      localStorage.setItem("currentuserImg", users[0].profileimageurl);
      return users[0].id;
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
}

const CustomPopup = ({ message, onClose }) => {
  const { direction } = useContext(LanguageContext);
  return (
    <div className={styles.popupOverlay}>
      <div className={styles.popupContent}>
        <p>{message}</p>
        <button onClick={onClose}>
          {direction === "rtl" ? "إغلاق" : "Close"}
        </button>
      </div>
    </div>
  );
};

function MyProfilePersonalInfo() {
  const { direction } = useContext(LanguageContext);
  const [email, setEmail] = useState("john.doe@example.com");
  const location = useLocation();

  // Add this check at the start of the component
  const userEmail = localStorage.getItem("useremailidis");

  if (!userEmail) {
    return (
      <div className={styles.loggedOutContainer}>
        <div className={styles.loggedOutMessage}>
          <h2>
            {direction === "rtl" ? "أنت غير مسجل الدخول" : "You are logged out"}
          </h2>
          <p>
            {direction === "rtl"
              ? "يرجى تسجيل الدخول للوصول إلى صفحة ملفك الشخصي"
              : "Please login to access your profile page"}
          </p>
          <Link to="/home/login" className={styles.loginButton}>
            {direction === "rtl" ? "تسجيل الدخول" : "Login"}
          </Link>
        </div>
      </div>
    );
  }

  useEffect(() => {
    getUserIdByEmail(localStorage.getItem("useremailidis"));

    // Fetch the profile data when the page loads
    const fetchProfile = async () => {
      try {
        // Make the API call to get profile by email
        const response = await axios.get(
          `${marketingBackendUrl}/maflam/profile/${localStorage.getItem(
            "useremailidis"
          )}`
        );

        // If successful, set the profile data in state
        setProfile(response.data.profile);
        localStorage.setItem("currentusername", response.data.profile.name);
      } catch (err) {
        // If an error occurs, display it
        setProfile(null); // Reset the profile data
      }
    };

    fetchProfile(); // Call the function to fetch the profile
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".customSelect")) {
        setShowCountryDropdown(false);
        setShowTimezoneDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const userimg = localStorage.getItem("currentuserImg");

  // State to store the user profile data
  const [profile, setProfile] = useState({
    name: "",
    email: "",
    phone: "",
    city: "",
    country: "",
    timezone: "",
    facebook: "",
    instagram: "",
    twitter: "",
    currentPassword: "",
    newPassword: "",
    verifyPassword: "",
    image: localStorage.getItem("currentuserImg"),
  });

  // Add these new states inside the component
  const [showCountryDropdown, setShowCountryDropdown] = useState(false);
  const [showTimezoneDropdown, setShowTimezoneDropdown] = useState(false);
  const [countrySearch, setCountrySearch] = useState("");
  const [timezoneSearch, setTimezoneSearch] = useState("");
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedTimezone, setSelectedTimezone] = useState(null);

  // Add these new states with other state declarations
  const [showGenderDropdown, setShowGenderDropdown] = useState(false);
  const [showAreaDropdown, setShowAreaDropdown] = useState(false);
  const [genderSearch, setGenderSearch] = useState("");
  const [areaSearch, setAreaSearch] = useState("");
  const [selectedGender, setSelectedGender] = useState(null);
  const [selectedArea, setSelectedArea] = useState(null);

  // Add these filter functions
  const filteredCountries = COUNTRIES.filter((country) => {
    const searchTerm = countrySearch.toLowerCase();
    return (
      country.label_en.toLowerCase().includes(searchTerm) ||
      country.label_ar.toLowerCase().includes(searchTerm)
    );
  });

  const filteredTimezones = TIMEZONES.filter((zone) => {
    const searchTerm = timezoneSearch.toLowerCase();
    return (
      zone.label_en.toLowerCase().includes(searchTerm) ||
      zone.label_ar.toLowerCase().includes(searchTerm)
    );
  });

  const filteredGenders = GENDERS.filter((gender) => {
    const searchTerm = genderSearch.toLowerCase();
    return (
      gender.label_en.toLowerCase().includes(searchTerm) ||
      gender.label_ar.toLowerCase().includes(searchTerm)
    );
  });

  const filteredAreas = AREAS_OF_INTEREST.filter((area) => {
    const searchTerm = areaSearch.toLowerCase();
    return (
      area.label_en.toLowerCase().includes(searchTerm) ||
      area.label_ar.toLowerCase().includes(searchTerm)
    );
  });

  // Handle form input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setProfile((prevProfile) => ({
      ...prevProfile,
      [name]: value,
    }));
  };
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setProfile((prevProfile) => ({
          ...prevProfile,
          image: reader.result, // Save base64 image string in state
        }));
      };

      // Convert the file to base64
      reader.readAsDataURL(file);
    }
  };

  // Function to read base64 image and convert it into image URL (for preview)
  const readBase64AsImage = (base64String) => {
    const img = new Image();
    img.src = base64String; // Set the src to base64 string
    return img; // Return the image object
  };

  // Update the country and timezone selection handlers
  const handleCountrySelect = (country) => {
    setSelectedCountry(country);
    setProfile((prev) => ({
      ...prev,
      country: country.value,
    }));
    setCountrySearch(direction === "rtl" ? country.label_ar : country.label_en);
    setTimeout(() => setShowCountryDropdown(false), 100); // Delay closing dropdown
  };

  const handleTimezoneSelect = (timezone) => {
    setSelectedTimezone(timezone);
    setProfile((prev) => ({
      ...prev,
      timezone: timezone.value,
    }));
    setTimezoneSearch(
      direction === "rtl" ? timezone.label_ar : timezone.label_en
    );
    setTimeout(() => setShowTimezoneDropdown(false), 100); // Delay closing dropdown
  };

  // Add these handlers
  const handleGenderSelect = (gender) => {
    setSelectedGender(gender);
    setProfile((prev) => ({
      ...prev,
      gender: gender.value,
    }));
    setGenderSearch(direction === "rtl" ? gender.label_ar : gender.label_en);
    setTimeout(() => setShowGenderDropdown(false), 100);
  };

  const handleAreaSelect = (area) => {
    setSelectedArea(area);
    setProfile((prev) => ({
      ...prev,
      areaOfInterest: area.value,
    }));
    setAreaSearch(direction === "rtl" ? area.label_ar : area.label_en);
    setTimeout(() => setShowAreaDropdown(false), 100);
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    const missingFields = [];
    if (!profile.name)
      missingFields.push(direction === "rtl" ? "الاسم الكامل" : "Full Name");
    if (!profile.email)
      missingFields.push(direction === "rtl" ? "البريد الإلكتروني" : "Email");
    if (!profile.phone)
      missingFields.push(direction === "rtl" ? "رقم الهاتف" : "Phone Number");
    if (!profile.city)
      missingFields.push(direction === "rtl" ? "المدينة" : "City");
    if (!profile.country)
      missingFields.push(direction === "rtl" ? "البلد" : "Country");

    if (missingFields.length > 0) {
      const missingFieldsText = missingFields.join(", ");
      setPopupMessage(
        direction === "rtl"
          ? `يرجى ملء الحقول المطلوبة: ${missingFieldsText}`
          : `Please fill in the required fields: ${missingFieldsText}`
      );
      setShowPopup(true);
      return;
    }

    if (profile.newPassword && profile.newPassword !== profile.verifyPassword) {
      setPopupMessage(
        direction === "rtl"
          ? "كلمة المرور الجديدة وتأكيد كلمة المرور غير متطابقتين"
          : "New password and confirm password do not match"
      );
      setShowPopup(true);
      return;
    }

    try {
      // Make an API call to update the profile
      const response = await axios.post(
        `${marketingBackendUrl}/maflam/update-profile`,
        profile,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // Handle the response from the API
      if (response.status === 200) {
        setPopupMessage(
          direction === "rtl"
            ? "تم تحديث الملف الشخصي بنجاح"
            : "Profile updated successfully"
        );
        setShowPopup(true);
      } else {
        setPopupMessage(
          direction === "rtl"
            ? "حدث خطأ أثناء تحديث الملف الشخصي"
            : "Error updating profile"
        );
        setShowPopup(true);
      }
    } catch (error) {
      setPopupMessage(
        direction === "rtl"
          ? "حدث خطأ أثناء تحديث الملف الشخصي"
          : "Error updating profile"
      );
      setShowPopup(true);
    }
  };

  // Add loader effect
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  const [popupMessage, setPopupMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  return (
    <div className={styles.container}>
      {showPopup && (
        <CustomPopup
          message={popupMessage}
          onClose={() => setShowPopup(false)}
        />
      )}
      {isLoading && (
        <div className={styles.loaderWrapper}>
          <span className={styles.loader}></span>
        </div>
      )}
      <ProfileNavigation />

      <div className={styles.profileContainer}>
        <header className={styles.profileHeader}></header>
        <form className={styles.profileForm} onSubmit={handleSubmit}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "end",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                maxWidth: "200px",
                gap: "5px",
                padding: "0px",
                color: "#BBFFFF",
              }}
              className={styles.imageUploadContainer}
            >
              <div className={styles.imagePreview}>
                <img src={localStorage.getItem("currentuserImg")} alt="" />

                <div className={styles.editIconContainer}>
                  <input
                    type="file"
                    accept="image/*"
                    id="image-upload"
                    className={styles.fileInput}
                    onChange={handleImageChange} // Handle image change
                  />
                </div>
              </div>
              <a
                href={`${MOODLE_BASE_URL}/user/edit.php?lang=${
                  direction === "rtl" ? "ar" : "en"
                }`}
                style={{
                  width: "100%",
                  textAlign: "center",
                  color: "rgb(57,255,251)",
                  textDecoration: "none",
                }}
                htmlFor="image-upload"
                className={styles.editIconLabel}
              >
                {direction === "rtl"
                  ? "تغيير صورة الملف الشخصي"
                  : "Change Profile Image"}
              </a>
            </div>
          </div>

          {/* Full Name */}
          <div className={styles.formGroup}>
            <label>
              {direction === "rtl" ? "الاسم الكامل" : "Full Name"}
              <span className={styles.required}>*</span>
            </label>
            <input
              type="text"
              name="name"
              value={profile.name}
              onChange={handleInputChange}
              placeholder={profile.name}
              // style={{ fontSize: "18px" }}
              className={!profile.name ? styles.missingField : ""}
            />
          </div>

          {/* Email */}
          <div className={styles.formGroup}>
            <label>{direction === "rtl" ? "البريد الإلكتروني" : "Email"}</label>
            <input
              style={{ color: "rgb(57,255,251)" }}
              type="email"
              name="email"
              value={profile.email}
              onChange={handleInputChange}
              placeholder="Email"
              disabled
            />
          </div>

          {/* Phone Number */}
          <div className={styles.formGroup}>
            <label>{direction === "rtl" ? "رقم الهاتف" : "Phone Number"}</label>
            <input
              style={{
                display: "flex",
                flexDirection: "row",
                textAlign: "flex-start",
              }}
              type="text"
              name="phone"
              value={profile.phone}
              onChange={handleInputChange}
              placeholder="Phone Number"
            />
          </div>

          {/* Gender Dropdown - after Full Name */}
          <div className={styles.formGroup}>
            <label>{direction === "rtl" ? "الجنس" : "Gender"}</label>
            <div className={styles.customSelect}>
              <input
                type="text"
                value={genderSearch}
                onChange={(e) => {
                  setGenderSearch(e.target.value);
                  setShowGenderDropdown(true);
                }}
                onFocus={() => setShowGenderDropdown(true)}
                onBlur={(e) => {
                  if (!e.relatedTarget?.closest(".${styles.dropdownList}")) {
                    setTimeout(() => setShowGenderDropdown(false), 200);
                  }
                }}
                placeholder={
                  profile.gender
                    ? direction === "rtl"
                      ? GENDERS.find((g) => g.value === profile.gender)
                          ?.label_ar
                      : GENDERS.find((g) => g.value === profile.gender)
                          ?.label_en
                    : direction === "rtl"
                    ? "اختر الجنس"
                    : "Select Gender"
                }
              />
              {showGenderDropdown && (
                <div
                  className={styles.dropdownList}
                  onMouseDown={(e) => e.preventDefault()}
                >
                  {filteredGenders.map((gender) => (
                    <div
                      key={gender.value}
                      className={`${styles.dropdownItem} ${
                        selectedGender?.value === gender.value
                          ? styles.selected
                          : ""
                      }`}
                      onMouseDown={() => handleGenderSelect(gender)}
                    >
                      {direction === "rtl" ? gender.label_ar : gender.label_en}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          <div className={styles.formGroup}>
            <label>{direction === "rtl" ? "العنوان" : "Address"}</label>
            <div style={{ gap: "10px" }} className={styles.dobGroup}>
              <div className={styles.formGroup}>
                <label>{direction === "rtl" ? "المدينة" : "City"}</label>
                <input
                  type="text"
                  name="city"
                  value={profile.city}
                  onChange={handleInputChange}
                  placeholder={direction === "rtl" ? "المدينة" : "City"}
                />
              </div>
              <div className={styles.formGroup}>
                <label>{direction === "rtl" ? "البلد" : "Country"}</label>
                <div className={styles.customSelect}>
                  <input
                    type="text"
                    value={countrySearch}
                    onChange={(e) => {
                      setCountrySearch(e.target.value);
                      setShowCountryDropdown(true);
                    }}
                    onFocus={() => setShowCountryDropdown(true)}
                    onBlur={(e) => {
                      if (
                        !e.relatedTarget?.closest(".${styles.dropdownList}")
                      ) {
                        setTimeout(() => setShowCountryDropdown(false), 200);
                      }
                    }}
                    placeholder={
                      profile.country
                        ? direction === "rtl"
                          ? COUNTRIES.find((c) => c.value === profile.country)
                              ?.label_ar
                          : COUNTRIES.find((c) => c.value === profile.country)
                              ?.label_en
                        : direction === "rtl"
                        ? "اكتب أو اختر البلد"
                        : "Type or select country"
                    }
                  />
                  {showCountryDropdown && (
                    <div
                      className={styles.dropdownList}
                      onMouseDown={(e) => e.preventDefault()}
                    >
                      {filteredCountries.map((country) => (
                        <div
                          key={country.value}
                          className={`${styles.dropdownItem} ${
                            selectedCountry?.value === country.value
                              ? styles.selected
                              : ""
                          }`}
                          onMouseDown={() => handleCountrySelect(country)}
                        >
                          {direction === "rtl"
                            ? country.label_ar
                            : country.label_en}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
              <div className={styles.formGroup}>
                <label>
                  {direction === "rtl" ? "المنطقة الزمنية" : "Time-zone"}
                </label>
                <div className={styles.customSelect}>
                  <input
                    type="text"
                    value={timezoneSearch}
                    onChange={(e) => {
                      setTimezoneSearch(e.target.value);
                      setShowTimezoneDropdown(true);
                    }}
                    onFocus={() => setShowTimezoneDropdown(true)}
                    onBlur={(e) => {
                      if (
                        !e.relatedTarget?.closest(".${styles.dropdownList}")
                      ) {
                        setTimeout(() => setShowTimezoneDropdown(false), 200);
                      }
                    }}
                    placeholder={
                      profile.timezone
                        ? direction === "rtl"
                          ? TIMEZONES.find((t) => t.value === profile.timezone)
                              ?.label_ar
                          : TIMEZONES.find((t) => t.value === profile.timezone)
                              ?.label_en
                        : direction === "rtl"
                        ? "اكتب أو اختر المنطقة الزمنية"
                        : "Type or select timezone"
                    }
                  />
                  {showTimezoneDropdown && (
                    <div
                      className={styles.dropdownList}
                      onMouseDown={(e) => e.preventDefault()}
                    >
                      {filteredTimezones.map((timezone) => (
                        <div
                          key={timezone.value}
                          className={`${styles.dropdownItem} ${
                            selectedTimezone?.value === timezone.value
                              ? styles.selected
                              : ""
                          }`}
                          onMouseDown={() => handleTimezoneSelect(timezone)}
                        >
                          {direction === "rtl"
                            ? timezone.label_ar
                            : timezone.label_en}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Area of Interest Dropdown - after Phone Number */}
          <div className={styles.formGroup}>
            <label>
              {direction === "rtl" ? "مجال الاهتمام" : "Area of Interest"}
            </label>
            <div className={styles.customSelect}>
              <input
                type="text"
                value={areaSearch}
                onChange={(e) => {
                  setAreaSearch(e.target.value);
                  setShowAreaDropdown(true);
                }}
                onFocus={() => setShowAreaDropdown(true)}
                onBlur={(e) => {
                  if (!e.relatedTarget?.closest(".${styles.dropdownList}")) {
                    setTimeout(() => setShowAreaDropdown(false), 200);
                  }
                }}
                placeholder={
                  profile.areaOfInterest
                    ? direction === "rtl"
                      ? AREAS_OF_INTEREST.find(
                          (a) => a.value === profile.areaOfInterest
                        )?.label_ar
                      : AREAS_OF_INTEREST.find(
                          (a) => a.value === profile.areaOfInterest
                        )?.label_en
                    : direction === "rtl"
                    ? "اختر مجال الاهتمام"
                    : "Select Area of Interest"
                }
              />
              {showAreaDropdown && (
                <div
                  className={styles.dropdownList}
                  onMouseDown={(e) => e.preventDefault()}
                >
                  {filteredAreas.map((area) => (
                    <div
                      key={area.value}
                      className={`${styles.dropdownItem} ${
                        selectedArea?.value === area.value
                          ? styles.selected
                          : ""
                      }`}
                      onMouseDown={() => handleAreaSelect(area)}
                    >
                      {direction === "rtl" ? area.label_ar : area.label_en}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Social Links */}
          <div className={styles.formGroup}>
            <label>
              {direction === "rtl"
                ? "روابط الشبكات الاجتماعية"
                : "Social Links"}
            </label>
            <div className={styles.linksGroup}>
              <input
                type="text"
                value={profile.facebook}
                onChange={handleInputChange}
                name="facebook"
                placeholder="https://www.facebook.com/username"
              />
              <input
                type="text"
                value={profile.instagram}
                onChange={handleInputChange}
                name="instagram"
                placeholder="https://www.instagram.com/username"
              />
              <input
                type="text"
                value={profile.twitter}
                onChange={handleInputChange}
                name="twitter"
                placeholder="https://www.twitter.com/username"
              />
            </div>
          </div>

          {/* Password Section */}
          <div className={styles.formGroup}>
            <label>
              {direction === "rtl" ? "تغيير كلمة المرور" : "Change Password"}
            </label>
            <div className={styles.switchable}>
              <div className={styles.formGroup}>
                <label>
                  {direction === "rtl"
                    ? "كلمة المرور الحالية"
                    : "Current Password"}
                </label>
                <input
                  type="password"
                  name="currentPassword"
                  value={profile.currentPassword}
                  onChange={handleInputChange}
                  placeholder="Current Password"
                  disabled
                  readOnly
                  style={{
                    backgroundColor: "rgba(221, 229, 234, 0.07)",
                    cursor: "not-allowed",
                  }}
                />
              </div>

              <div className={styles.formGroup}>
                <label>
                  {direction === "rtl" ? "كلمة المرور الجديدة" : "New Password"}
                </label>
                <input
                  type="password"
                  name="newPassword"
                  value={profile.newPassword}
                  onChange={handleInputChange}
                  placeholder="New Password"
                />
              </div>

              <div className={styles.formGroup}>
                <label>
                  {direction === "rtl"
                    ? "تأكيد كلمة المرور"
                    : "Confirm Password"}
                </label>
                <input
                  type="password"
                  name="verifyPassword"
                  value={profile.verifyPassword}
                  onChange={handleInputChange}
                  placeholder="Verify Password"
                />
              </div>
            </div>
          </div>

          {/* Save Button */}
          <button type="submit" className={styles.submitButton}>
            {direction === "rtl" ? "حفظ التغييرات" : "Save Changes"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default MyProfilePersonalInfo;
